import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useFetchTicketDetails from '../../hooks/useApi/useFetchTicketDetails';

import TicketCommentsContainer from './TicketComments/TicketCommentsContainer';
import { useTranslation } from 'react-i18next';

const { Box, Title, BackButton, SubTitle } = vp;

type FC = FunctionComponent;
const TicketDetails: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [ticketDetail, getTicket] = useFetchTicketDetails({});
  const { t } = useTranslation('translations', { keyPrefix: 'Tickets.Details' });

  useEffect(() => {
    getTicket({ TicketID: id });
  }, []);

  return (
    <div>
      <Box mb="md" jc="fs" ai="center" gap="common">
        <BackButton variant="arrow" backButtonEnabled />
        <Title title={t('pageTitle', { subject: ticketDetail?.Ticket?.subject || '' })} />
      </Box>
      <Box mb="md" pt="sm" pb="sm">
        <SubTitle subTitle={t('ticketID', { ticketID: ticketDetail?.Ticket?.id || '' })} variant="small" />
      </Box>
      <TicketCommentsContainer
        ticketDetail={ticketDetail}
        refreshTicket={() => {
          getTicket({ TicketID: id });
        }}
      />
    </div>
  );
};

export default TicketDetails;
